<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false" @close="qx()">
    <el-form   label-position="raght" :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      
      <el-form-item label-width="120px" label="渠道名称" prop="name">
          <el-input v-model="dataForm.name" placeholder="渠道名称" ></el-input>
      </el-form-item>
      
      
      <el-form-item label-width="120px" label="回调URL" prop="url">
          <el-input v-model="dataForm.url" placeholder="回传URL"></el-input>
      </el-form-item>
          <el-form-item label-width="120px" label="回传token" prop="token">
          <el-input v-model="dataForm.token" placeholder="回传token"></el-input>
      </el-form-item>
      <el-form-item label-width="120px" label="星级回传url" prop="starUrl">
          <el-input v-model="dataForm.starUrl" placeholder="星级回传url"></el-input>
      </el-form-item>
      <el-form-item label-width="120px" label="撞库返URL" prop="checkUrl">
          <el-input v-model="dataForm.checkUrl" placeholder="撞库返URL"></el-input>
      </el-form-item>
      <el-form-item label-width="120px" label="响应时间" prop="responseTime">
          <el-input v-model="dataForm.responseTime" placeholder="响应时间（单位：秒）"></el-input>
      </el-form-item>
      <el-form-item  label-width="120px" label="代运营机构" prop="operationIdList">
	      <el-select  class="hundred"  v-model="dataForm.operationIdList" filterable multiple placeholder="请选择">
	          <el-option
	                  v-for="item in operationList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item>
      <div style="display: flex; flex-wrap: wrap;">
        <el-form-item label-width="120px" label="渠道对接方式" prop="chargingMode">
          <el-select @change="changeMethod" style="width: 200px;" v-model="dataForm.chargingMode" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in modeList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  label-width="120px" label="渠道结算方式" prop="settlementMethod">
          <el-select @change="changeSettlement" :disabled="setDisabled" style="width: 200px;" v-model="dataForm.settlementMethod" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in settlementList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="120px" label="渠道结算价格" prop="price">
          <div style="display: flex;">
            <el-input :disabled="priceDisabled" style="width: 175px;" v-model="dataForm.price" placeholder="请输入"></el-input>
            <span style="padding-left: 10px;">元</span>
          </div>
        </el-form-item>
        <el-form-item v-if="dataForm.settlementMethod == '1' || dataForm.settlementMethod == '2'" label-width="120px" label="渠道分润比例" prop="ratio">
            <el-input style="width: 200px;" v-model="dataForm.ratio" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item v-if="dataForm.settlementMethod == '0' && (dataForm.chargingMode=='2' || dataForm.chargingMode=='4')" label-width="120px" label="渠道平推价" prop="channelFlatPrice">
          <div style="display: flex;">
            <el-input style="width: 175px;" v-model="dataForm.channelFlatPrice" placeholder="请输入"></el-input>
            <span style="padding-left: 10px;">元</span>
          </div>
        </el-form-item>
        <el-form-item v-if="dataForm.chargingMode=='2' || dataForm.chargingMode=='4'" label-width="120px" label="起推价" prop="startPrice">
          <div style="display: flex;">
            <el-input style="width: 175px;" v-model="dataForm.startPrice" placeholder="请输入"></el-input>
            <span style="padding-left: 10px;">元</span>
          </div>
        </el-form-item>
      </div>
      <div style="display:flex">
      <el-form-item label-width="120px" label="状态" prop="status">
          <el-select style="width: 200px;" v-model="dataForm.status" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in statusList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
      </el-form-item>
     
      
      <el-form-item label-width="120px" label="去重" prop="operationIdList">
	      <el-select style="width: 200px;" v-model="dataForm.repeatFlag" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in repeatFlagList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item>
    </div>
    <div style="display: flex;flex-wrap: wrap;">
      <el-form-item label-width="120px" label="是否回传" prop="callFlag">
	      <el-select style="width: 200px;" v-model="dataForm.callFlag" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in callFlagList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item>
      <el-form-item v-if="(dataForm.settlementMethod == '0' &&  (dataForm.chargingMode=='2' || dataForm.chargingMode=='4')) || dataForm.settlementMethod == '1' || dataForm.settlementMethod == '2'"  label-width="120px" label="协议确认" prop="returnStatus">
	      <el-select   style="width: 200px;"  v-model="dataForm.returnStatus" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in returnList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item>
      <el-form-item label-width="120px" label="是否掩码" prop="mark">
	      <el-select style="width: 200px;" v-model="dataForm.mark" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in markList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item>
      <el-form-item label-width="120px" label="是否参与计数" prop="deduct">
	      <el-select :disabled="setDisabled" style="width: 200px;" v-model="dataForm.deduct" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in callFlagList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item>
      <el-form-item label-width="120px" label="APP下载模式" prop="downloadApp">
        <el-select style="width: 200px;" v-model="dataForm.downloadApp" filterable clearable placeholder="请选择">
          <el-option
              v-for="item in downloadAppList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="120px" v-if="dataForm.deduct == 1" label="百分比" prop="percent" >
         <div style="display: flex; align-items: center;">
           <el-input  style="width: 180px;" v-model="dataForm.percent" placeholder="10倍数填写"></el-input>
           <div style="margin-left: 6px;">%</div>
         </div>
      </el-form-item>
      <el-form-item label-width="120px" v-if="dataForm.deduct == 1" label="最小值" prop="minSize" >
          <el-input  style="width: 200px;" v-model="dataForm.minSize" placeholder="10倍数填写"></el-input>
      </el-form-item>
    </div>
    <el-form-item label-width="120px" label="城市价格设置" prop="cityPriceSetting">
         <div class="city_set">

          <el-tag class="tag_item" size="medium" closable v-for="(item,index) in dataForm.cityPriceSetting" :key="index"  @close="closeTag(item)">{{item.city}}：￥{{item.price}}</el-tag>

           <el-button class="city_btn" size="mini" @click="openCitySelect">+</el-button>
         </div>
      </el-form-item>
      <el-form-item label-width="120px" label="备注" prop="remark">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="备注"
            v-model="dataForm.remark">
          </el-input>
      </el-form-item>
      </el-form>
      <el-dialog
        width="30%"
        title="城市价格设置"
        :visible.sync="isSelectCity"
        append-to-body>
        <el-form ref="form" :model="cityForm" label-width="80px">
          <el-form-item label="城市" :rules="[{ required: true, message: this.$t('validate.required'), trigger: 'blur' }]">
            
            <el-select style="width: 200px;" v-model="cityForm.city" filterable clearable placeholder="请选择城市">
            <el-option
                    v-for="item in citys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
           <el-form-item label="价格"  :rules="[{ required: true, message: this.$t('validate.required'), trigger: 'blur' }]">
            <el-input style="width: 200px;" v-model="cityForm.cityPrice" placeholder="请输入价格"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isSelectCity = false">取 消</el-button>
          <el-button type="primary" @click="confirmCity()">确 定</el-button>
        </span>
      </el-dialog>
    <template slot="footer">
      <el-button @click="qx()">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
    
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      isSelectCity:false,
      visible: false,
      operationList:[],
      setDisabled: false,
      priceDisabled:false,
      statusList:[
        {
            'label':'停用',
            'value':0,
        },
        {
            'label':'正常',
            'value':1,
        }
      ],
      repeatFlagList:[
      {
            'label':'不去重',
            'value':0,
        },
        {
            'label':'去重',
            'value':1,
        }
      ],
      callFlagList:[
      {
            'label':'否',
            'value':0,
        },
        {
            'label':'是',
            'value':1,
        }
      ],
      downloadAppList:[
        {
          'label':'否',
          'value':0,
        },
        {
          'label':'是',
          'value':1,
        }
      ],
      returnList:[
      {
            'label':'进件返',
            'value':1,
        },
        {
            'label':'撞库返',
            'value':2,
        },
        {
            'label':'全流程返',
            'value':3,
        }
      ],
      markList:[
        {
            'label':'掩码',
            'value':1,
        },
        {
            'label':'非掩码',
            'value':0,
        }
      ],
      modeList:[],
      settlementList:[],
      citys:[],
      cityForm:{
        city:'',
        cityPrice:'',
      },
      dataForm: {
        cityPriceSetting:[],
        percent:'10',
        minSize:'0',
        id: '',
        name: '',
        remark: '',
        operationIdList: '',
        url: '',
        token: '',
        status: '',
        starUrl: '',
        repeatFlag:'',
        chargingMode:'',
        settlementMethod:'',
        ratio:'1',
        channelFlatPrice:'0',
        price:'',
        callFlag:'',
        checkUrl:'',
        returnStatus:'',
        deduct:'',
        mark: 0,
        startPrice: '0',
        responseTime:''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        percent: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const num = Number(value);
              if (isNaN(num)) {
                callback(new Error('请输入数字'));
              } else if (num < 0 || num > 100) {
                callback(new Error('范围必须是 0-100'));
              }  else {
                callback();
              }
              },
            trigger: 'blur'
          }
        ],
        minSize: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const num = Number(value);
              if (isNaN(num)) {
                callback(new Error('请输入数字'));
              } else {
                callback();
              }
              },
            trigger: 'blur'
          }
        ],
        mark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        returnStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        operationIdList: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        url: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        checkUrl: [
          { required: false, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        token: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { required: true,min:8, message: '长度必须大于8位', trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        chargingMode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        settlementMethod: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        callFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deduct: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        ratio: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value < 0 || value > 1) {
                callback(new Error('请输入有效值'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        channelFlatPrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        price: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getModeOptions()
    this.getsettlementMethod()
  },
  methods: {
    init () {
      this.getOperatorsOptions();
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    //初始化下拉框中的选项
      async getCityOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.citys=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.citys.push({label:element.dictLabel,value:element.dictValue})
          })
        }
      }).catch(() => {})
    },
    //初始化下拉框中的选项
    async getModeOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=charging_mode`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.modeList=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.modeList.push({label:element.dictLabel,value:element.dictValue})
          })
        }
      }).catch(() => {})
    },
    async getsettlementMethod() {
      this.$http.get(`/sys/dict/data/list?dataType=settlementMethod`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.settlementList=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.settlementList.push({label:element.dictLabel,value:element.dictValue})
          })
        }
      }).catch(() => {})
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/channels/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data,
          // repeatFlag: res.data.repeatFlag == '1' ? '去重' : '不去重' 
        }
        if(this.dataForm.cityPriceSetting == null || this.dataForm.cityPriceSetting === ''){
          this.dataForm.cityPriceSetting = null
        }else{
          try {
            this.dataForm.cityPriceSetting = JSON.parse(this.dataForm.cityPriceSetting)
          } catch (e) {
            this.dataForm.cityPriceSetting = null
          }
        }
        
        if(this.dataForm.returnStatus == 0){
          this.dataForm.returnStatus = null
        }
        if(this.dataForm.chargingMode == '0' || this.dataForm.chargingMode == '1' || this.dataForm.chargingMode == '3'){
          this.setDisabled = true
          this.dataForm.settlementMethod = '0'
          this.dataForm.returnStatus = ''
        }else{
          this.setDisabled = false
        }
        if(this.dataForm.settlementMethod == '1' || this.dataForm.settlementMethod == '2'){
          this.priceDisabled = true
          this.dataForm.price = '0'
        }else{
          this.priceDisabled = false

        }
        this.dataForm.chargingMode = this.dataForm.chargingMode.toString()
        this.dataForm.settlementMethod = this.dataForm.settlementMethod.toString()
      }).catch(() => {})
    },
    //初始化运营机构下拉框的选项
    async getOperatorsOptions() {
        this.$http.get(`/sys/operations/listAll`).then(({data: res}) => {
          console.log(res)
            if (res.code !== 0) {
                return this.$message.error(res.msg)
            }
            this.operationList = [];
            if (res.data != null) {
                res.data.forEach(element => {
                    this.operationList.push({label: element.name, value: element.id})
                })
            }
        }).catch(() => {
        })
    },
    changeMethod(){
      this.priceDisabled = false
      if(this.dataForm.chargingMode == '0' || this.dataForm.chargingMode == '1' || this.dataForm.chargingMode == '3'){
        this.setDisabled = true
        this.dataForm.settlementMethod = '0'
        this.dataForm.deduct = 0
        this,this.dataForm.returnStatus = ''
      }else{
        this.setDisabled = false
      }
    },
    changeSettlement(){
      if(this.dataForm.settlementMethod == '1' || this.dataForm.settlementMethod == '2'){
        this.priceDisabled = true
        this.dataForm.price = '0'
      }else{
        this.priceDisabled = false

      }
    },
    openCitySelect(){
      this.getCityOptions();
      this.isSelectCity = true
    },
    closeTag(item){
      this.dataForm.cityPriceSetting.splice(this.dataForm.cityPriceSetting.indexOf(item),1)
    },
    confirmCity(){ 
      this.dataForm.cityPriceSetting.push({
        city: this.cityForm.city,
        price: this.cityForm.cityPrice
      })
      console.log(1231, this.dataForm.cityPriceSetting);
      
      this.isSelectCity = false
      this.cityForm.city= ''
      this.cityForm.cityPrice=''
    },
    qx(){
      this.visible = false
      this.dataForm = {
        percent:'10',
        minSize:'0',
        id: '',
        name: '',
        remark: '',
        operationIdList: '',
        url: '',
        token: '',
        status: '',
        starUrl: '',
        repeatFlag:'',
        chargingMode:'',
        settlementMethod:'',
        ratio:'1',
        channelFlatPrice:'0',
        price:'',
        callFlag:'',
        checkUrl:'',
        returnStatus:'',
        deduct:'',
        mark: 0,
        startPrice: '0',
        responseTime:''
      }
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
      
        for (const key in this.dataForm) {
          if (Object.hasOwnProperty.call(this.dataForm, key) && typeof this.dataForm[key] == 'string') {
              this.dataForm[key] = this.dataForm[key].replace(/^\s*|\s*$/g,"");
          }
        }
        if(this.dataForm.ratio == "" || this.dataForm.ratio == null){
          delete this.dataForm.ratio
        }
        if(this.dataForm.channelFlatPrice == "" || this.dataForm.channelFlatPrice == null){
          delete this.dataForm.channelFlatPrice
        }
        if(!this.dataForm.returnStatus){
          this.dataForm.returnStatus = 0
        }
        this.dataForm.cityPriceSetting = JSON.stringify(this.dataForm.cityPriceSetting)
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/channels/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style lang="scss" scoped>
.city_set{
  border: 1px solid #dcdfe6;
  width: 100%;
  min-height: 40px;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
}
// .city_btn{
  // margin-left: 10px;
// }
.tag_item{
  margin-right: 10px;
}
</style>
